import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Dashboard landing page for the Mission Impact admin portal
 */
export default function DashboardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Dashboard</h1>
        <p className="text-muted-foreground">
          Welcome to the Mission Impact Administration Portal
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Mission Impact Admin</CardTitle>
          <CardDescription>
            Central administration dashboard for managing Mission Impact products and services.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p>
            Use this portal to manage products, subscriptions, legal documents, system notices,
            and notification templates across all Mission Impact applications.
          </p>
          <p className="text-muted-foreground">
            Select an option from the sidebar to get started.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
